"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getGaryDomain = exports.garyDomains = exports.getWebDomain = exports.domains = void 0;
const constants_1 = require("./constants");
exports.domains = Object.freeze({
    [constants_1.Segment.Fixter_UK]: {
        [constants_1.Stage.DEVELOPMENT]: 'fixter-dev.co.uk',
        [constants_1.Stage.STAGING]: 'fixter-staging.co.uk',
        [constants_1.Stage.PRODUCTION]: 'fixter.co.uk',
    },
    [constants_1.Segment.Fixter_FR]: {
        [constants_1.Stage.DEVELOPMENT]: 'fixter-dev.fr',
        [constants_1.Stage.STAGING]: 'fixter-staging.fr',
        [constants_1.Stage.PRODUCTION]: 'fixter.fr',
    },
});
const getWebDomain = (segment, stage) => {
    return exports.domains[segment][stage];
};
exports.getWebDomain = getWebDomain;
exports.garyDomains = Object.freeze({
    [constants_1.Segment.Fixter_UK]: {
        [constants_1.Stage.DEVELOPMENT]: 'app.garages.dev.fixter.co.uk',
        [constants_1.Stage.STAGING]: 'app.garages.staging.fixter.co.uk',
        [constants_1.Stage.PRODUCTION]: 'app.garages.fixter.co.uk',
    },
    [constants_1.Segment.Fixter_FR]: {
        [constants_1.Stage.DEVELOPMENT]: 'app.garages.dev.fixter.co.uk',
        [constants_1.Stage.STAGING]: 'app.garages.staging.fixter.co.uk',
        [constants_1.Stage.PRODUCTION]: 'app.garages.fixter.co.uk',
    },
});
const getGaryDomain = (segment, stage) => {
    return exports.garyDomains[segment][stage];
};
exports.getGaryDomain = getGaryDomain;
//# sourceMappingURL=domain.js.map